import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "new_template_modal"
}
const _hoisted_2 = { style: {"display":"flex","flex":"1","margin-bottom":"20px"} }
const _hoisted_3 = {
  class: "ap-input-label",
  style: {"margin-bottom":"10px"}
}
const _hoisted_4 = ["placeholder"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ApEditInput = _resolveComponent("ApEditInput")!
  const _component_MessageBlock = _resolveComponent("MessageBlock")!
  const _component_ap_button = _resolveComponent("ap-button")!
  const _component_ApModalBase = _resolveComponent("ApModalBase")!

  return (_openBlock(), _createBlock(_component_ApModalBase, {
    name: _ctx.name,
    titleIcon: 'ap-icon-template_icon',
    title: _ctx.$t('page.email-list.actions.add-new-template'),
    showClose: true,
    width: 675,
    height: null,
    onOpen: _ctx.beforeOpen,
    cancelOverflow: true,
    "cancel-text": _ctx.$t('modal.close')
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_ap_button, {
        "btn-class": "btn-primary",
        onClick: _ctx.modalSearch
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('modal.save')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      (_ctx.newTemplate)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_ApEditInput, {
                editing: true,
                name: "CampaignName",
                style: {"width":"466px"}
              }, {
                title: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('page.send-email.content.campaign.title')), 1)
                ]),
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    class: "ap-input w-100",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newTemplate.Name) = $event)),
                    style: {"min-width":"466px"},
                    placeholder: _ctx.$t('page.send-email.content.campaign.title')
                  }, null, 8, _hoisted_4), [
                    [_vModelText, _ctx.newTemplate.Name]
                  ])
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_MessageBlock, {
              id: "email-template-message",
              modelValue: _ctx.newTemplate.HTML,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newTemplate.HTML) = $event)),
              showSelectTemplate: false
            }, null, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["name", "title", "onOpen", "cancel-text"]))
}